import _extends from "@babel/runtime/helpers/extends";
import classNames from "classnames/dedupe";
import PropTypes from "prop-types";
import React from "react";
import { TextInput } from "../text-input";
export const Select = /*#__PURE__*/React.forwardRef(
/**
 *
 * @param {Object} props
 * @param {any} [props.children]
 * @param {any} [props.className]
 * @param {string} [props.name]
 * @param {boolean} [props.valid]
 * @param {boolean} [props.multiple]
 * @param {boolean} [props.disabled]
 * @param {string} [props.value]
 * @param {import("react").ChangeEventHandler<HTMLSelectElement>} [props.onChange]
 * @param {boolean} [props.readOnly]
 * @param {*} ref
 * @returns {JSX.Element}
 */
function Select({
  valid,
  children,
  className,
  name,
  multiple,
  disabled,
  readOnly = false,
  value,
  ...props
}, ref) {
  const activeClasses = "border-en-gray-600 hover:border-en-gray-900 focus:border-en-yellow-700";
  const validClasses = "focus:border-en-green";
  const invalidClasses = "border-en-red focus:border-en-red hover:border-en-red";
  const disabledClasses = "border-en-gray-600 bg-en-gray-100";
  const singleClasses = "form-select";
  const multipleClasses = "form-multiselect";

  const hasValidation = () => ![null, undefined].includes(valid);

  const validationStyle = () => {
    if (hasValidation()) {
      return valid ? validClasses : invalidClasses;
    }
  };

  const selectClasses = classNames(["select-container w-full border rounded-md p-2 pr-6 caret-en-yellow-700", "focus:outline-none"], {
    "bg-white": !disabled
  }, // don't apply activeStyle if has valid or disabled
  !hasValidation() && !disabled && activeClasses, // don't apply disabledStyle if has valid
  !hasValidation() && disabled && disabledClasses, validationStyle(), !multiple && singleClasses, multiple && multipleClasses);
  const wrapperClasses = classNames(["relative", "inline-block"], className);
  const iconClasses = classNames(["absolute", "w-6", "right-0", "top-0", "mr-1", "mt-2", "pointer-events-none"]);
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClasses
  }, !multiple && /*#__PURE__*/React.createElement("svg", {
    className: iconClasses,
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
    clipRule: "evenodd"
  })), readOnly ? /*#__PURE__*/React.createElement(TextInput, {
    value: React.Children.toArray(children) // @ts-ignore
    .filter(child => child.type === "option") // @ts-ignore
    .find(child => child.props.value === value).props.children || "",
    name: name,
    placeholder: "",
    readOnly: true
  }) : /*#__PURE__*/React.createElement("select", _extends({
    className: selectClasses,
    ref: ref,
    disabled: disabled,
    multiple: !!multiple,
    name: name,
    value: value
  }, props), children));
});
Select.propTypes = {
  children: PropTypes.node,
  multiple: PropTypes.bool,
  valid: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  readOnly: PropTypes.bool
};